import { useQuery } from '@tanstack/react-query';
import { NOTIFICATION_STYLE_LIST } from 'src/constants/queryKeys';
import axiosInstance from 'src/utils/axios';

export const networkGetNotificationStyleInfo = async (id) => {
  const res = await axiosInstance.post(`NotificationStyle/Info/${id}`);
  return res;
};

export const networkGetNotificationStyleList = async () => {
  const res = await axiosInstance.post('NotificationStyle/List');
  return res;
};

export function useFetchNotificationStyleList() {
  return useQuery({
    queryKey: [NOTIFICATION_STYLE_LIST],
    queryFn: () => networkGetNotificationStyleList(),
  });
}

export const networkUpdateNotificationStyle = async (id, data) => {
  const res = await axiosInstance.post(`NotificationStyle/Update/${id}`, data);
  return res;
};

export const networkRemoveNotificationStyle = async (id) => {
  const res = await axiosInstance.post(`NotificationStyle/Remove/${id}`);
  return res;
};

export const networkCreateNotificationStyle = async (data) => {
  const res = await axiosInstance.post('NotificationStyle/Insert', data);
  return res;
};
